import { LoanProductCategory } from '@mediaingenuity/totallymoney.types'
import Image from 'next/image'

import Box from '@totallymoney/ui/components/Box'
import Flex from '@totallymoney/ui/components/Flex'
import Grid from '@totallymoney/ui/components/Grid'
import Heading from '@totallymoney/ui/components/Heading'
import Text from '@totallymoney/ui/components/Text'

import womanWithMagnifyingGlass from '@images/woman-with-magnify-glass.png'

const NoResultsBanner = ({ category }: { category: LoanProductCategory }) => {
    const content = (() => {
        switch (category) {
            case 'AlternativeProducts': {
                return {
                    title: 'Sorry, we couldn‘t find any results',
                    description: '',
                }
            }
            default: {
                return {
                    title: 'Sorry, we couldn‘t find any results',
                    description:
                        'Try searching again with a different loan amount or term',
                }
            }
        }
    })()

    return (
        <Grid>
            <Flex gridColumn="1/13" justifyContent="center">
                <Flex justifyContent="center" pr="space30">
                    <Image
                        src={womanWithMagnifyingGlass}
                        alt="Woman holding a magnifying glass"
                        width="100"
                        height="100"
                        priority={true}
                    />
                </Flex>

                <Flex justifyContent="center" flexDirection="column">
                    <Box mb="space05">
                        <Heading variant="60">{content.title}</Heading>
                    </Box>

                    <Text variant="100" color="light">
                        {content.description}
                    </Text>
                </Flex>
            </Flex>
        </Grid>
    )
}

export default NoResultsBanner
